import React from "react";
import slugs from "../../resources/slugs";
import {
  PiChartPieSliceLight,
  PiUsersFourLight,
  PiSwapLight,
  PiStorefrontLight,
  PiShieldCheckLight,
  PiScrollLight,
  PiCreditCardLight,
  PiQrCodeLight,
  PiBankLight,
  PiGearLight,
  PiHandCoinsLight,
  PiPackageLight,
  PiMegaphoneLight,
  PiCoinsLight,
} from "react-icons/pi";
import Icon from "@ant-design/icons";

export default function getMenuData() {
  return [
    {
      title: "Dashboard",
      key: "dashboards",
      icon: <Icon component={PiChartPieSliceLight} />,
      children: [
        {
          title: "Overview",
          key: "overview",
          url: slugs.dashboard,
        },
        {
          title: "Overview Analysis",
          key: "overviewAnalysis",
          url: slugs.dashboardAnalysis,
        },
        {
          title: "POS Overview",
          key: "posOverview",
          url: slugs.posDashboard,
        },
      ],
    },

    {
      title: "Admin Management",
      key: "adminManagement",
      icon: <Icon component={PiShieldCheckLight} />,
      children: [
        {
          title: "Manage Admins",
          key: "viewAdmin",
          url: slugs.admin,
        },
        {
          title: "Create Admin",
          key: "createAdmin",
          url: `${slugs.admin}?action=create`,
        },
      ],
    },
    {
      title: "Customer Management",
      key: "customerManagement",
      icon: <Icon component={PiUsersFourLight} />,
      children: [
        {
          title: "All Customers",
          key: "viewAllCustomers",
          url: slugs.all_users,
        },
        {
          title: "Individual Customers",
          key: "viewIndividualCustomers",
          url: `${slugs.all_users}?type=individual`,
        },
        {
          title: "Corporate Customers",
          key: "viewCorporateCustomers",
          url: "/manage-corporate?type=corporate",
        },
      ],
    },
    {
      title: "B2B Customer Management",
      key: "b2bCustomerManagement",
      icon: <Icon component={PiUsersFourLight} />,
      children: [
        /* {
          title: "B2B Merchants",
          key: "manageB2BMerchants",
          url: slugs.busers,
        }, */
        {
          title: "Registered B2B Users",
          key: "viewRegisteredB2BUsers",
          url: slugs.users,
        },
      ],
    },
    {
      title: "Transactions",
      key: "transactions",
      icon: <Icon component={PiSwapLight} />,
      children: [
        {
          title: "All Transactions",
          key: "allTransactions",
          url: slugs.transactions,
        },
        {
          title: "Bills Payment",
          key: "billsPayment",
          url: slugs.bills_payment,
        },

        {
          title: "Products Transactions",
          key: "tran_p",
          url: slugs.transaction_p,
        },
        {
          title: "Products Pricing",
          key: "pricing",
          url: slugs.pricing,
        },
        // {
        //   title: "SMU Transactions",
        //   key: "smuTransations",
        //   url: slugs.smu_transactions,
        // },
        /*{
          title: "Queued Transactions",
          key: "queuedTransactions",
          url: slugs.queued_transactions,
        },*/ /*
        {
          title: "Transactions Charges",
          key: "transactionCharges",
          url: slugs.transaction_charge,
        },*/
        // {
        //   title: "Bills Payment",
        //   key: "billsPayment",
        //   url: slugs.bills_pay,
        // },
        // {
        //   title: "Payment Requests",
        //   key: "paymentRequest",
        //   url: slugs.payment_request,
        // },
        /*  {
            title: "Refunds",
            key: "refunds",
            url: slugs.refunds,
          },
         
          {
            title: "Retrieve Payments",
            key: "retrievePayment",
            url: slugs.retrieve_payment,
          },*/
        // {
        //   title: "Non Waya Transfers",
        //   key: "nonWayaTransfer",
        //   url: slugs.non_waya_transfer,
        // },
        {
          title: "Commissions",
          key: "commission",
          url: slugs.trans_commissions,
        },
        {
          title: "NIP Inward Reconciliation",
          key: "nipInwardReconciliation",
          url: slugs.nip_inward_reconciliation,
        },
        // {
        //   title: "Accounts",
        //   key: "accounts",
        //   url: slugs.trans_accounts,
        // },
      ],
    },
    {
      title: "POS Dashboard",
      key: "managepos",
      icon: <Icon component={PiStorefrontLight} />,
      children: [
        {
          title: "Manage POS",
          key: "pos",
          url: slugs.manage_pos,
        },
        {
          title: "POS Transactions",
          key: "allTransations",
          url: slugs.pos_transactions,
        },
        {
          title: "Routing",
          key: "routing",
          url: "/routing",
        },
        {
          title: "Manage  Merchants",
          key: "manageBUsers",
          url: slugs.busers,
        },
        {
          title: "Defaulters Log",
          key: "log",
          url: slugs.defaulters_log,
        },
        // {
        //   title: "Logs",
        //   key: "requestlogs",
        //   url: slugs.pos_request_logs,
        // },
        {
          title: "Terminal Activity Logs",
          key: "terminalActivityLogs",
          url: slugs.terminal_activity_logs,
        },
        {
          title: "AG Dashboard",
          key: "agDashboard",
          url: slugs.ag_dashboard,
        },
      ],
    },
    {
      title: "Manage KYC",
      key: "managekyc",
      icon: <Icon component={PiShieldCheckLight} />,
      children: [
        {
          title: "KYC",
          key: "kyc",
          url: slugs.manage_kyc,
        },
      ],
    },
    {
      title: "Fraud Management",
      key: "fraud_management",
      icon: <Icon component={PiShieldCheckLight} />,
      url: slugs.fraud_check,
    },
    {
      title: "Reversal Ops",
      key: "reversal_ops",
      icon: <Icon component={PiSwapLight} />,
      url: slugs.reversal_ops,
    },

    // {
    // title: "Business Reporting",
    // key: "rports",
    // icon: <Icon component={TransactionsIcon} />,
    // children: [
    // {
    //   title: "Manual Reports",
    //   key: "manualTransations",
    //   url: slugs.report,
    // },
    // {
    //   title: "All Transactions Categories Report",
    //   key: "allTransationsRep",
    //   url: slugs.all_transactions,
    // },
    // {
    //   title: "Users Payment Request Report",
    //   key: "paymentRequest",
    //   url: slugs.payment_request,
    // },

    /*{
      title: "Users Bills Payment Report",
      key: "billsPayment",
      url: slugs.bills_pay,
    },
    /*{
      title: "Users Withdrawal Report",
      key: "withdrawal",
      url: slugs.all_transactions,
    },
    {
      title: "Users Funding Report",
      key: "fundingReport",
      url: slugs.all_transactions,
    },
    {
      title: "Users Internal Transfers Report",
      key: "internalreport",
      url: slugs.all_transactions,
    },*/
    // {
    //   title: "Users Non Waya Transfer Report",
    //   key: "nonWayaTransfer",
    //   url: slugs.non_waya_transfer,
    // },
    /*{
      title: "Users Profile Details Report",
      key: "profileReport",
      url: slugs.non_waya_transfer,
    },
    /*{
      title: "Users KYC Report",
      key: "kyc",
      url: slugs.user_tier_levels,
    },*/
    // {
    //   title: "QR Codes Report",
    //   key: "qrreport",
    //   url: slugs.qr_codes,
    // },
    // {
    //   title: "Field Marketers Report",
    //   key: "fieldM",
    //   url: slugs.qr_codes,
    // },

    // {
    //   title: "Dispute Report",
    //   key: "dispute",
    //   url: slugs.dispute,
    // },

    // {
    //   title: "Audit Log Report",
    //   key: "auditReport",
    //   url: slugs.admin_audit,
    // },
    // {
    //   title: "Request Log Report",
    //   key: "requestReport",
    //   url: slugs.requests_logs,
    // },
    // {
    //   title: "Referral Report",
    //   key: "referral",
    //   url: slugs.referral,
    // },
    // {
    //   title: "Commission Report",
    //   key: "commission",
    //   url: slugs.trans_commissions,
    // },
    // {
    //   title: "Users Bank Account Report",
    //   key: "accountReport",
    //   url: slugs.trans_accounts,
    // },
    // {
    //   title: "Waya Official Accounts Transaction Report",
    //   key: "wayaOfficialTranReport",
    //   url: slugs.waya_official,
    // },
    /*{
      title: "Waya Official Withrawal Report",
      key: "wayaOfficialWithdrawalReport",
      url: slugs.waya_official,
    },
    {
      title: "Waya Official Internal Transfer Report",
      key: "wayaOfficialInternalReport",
      url: slugs.waya_official,
    },
    {
      title: "Waya Official Funding Report",
      key: "wayaOfficialFundingReport",
      url: slugs.waya_official,
    },*/
    // {
    //   title: "Waya Official Bank Accounts Report",
    //   key: "wayaOfficialAccountsReport",
    //   url: slugs.waya_official,
    // },

    //   ],
    // },
    // {
    //   title: "KYC",
    //   key: "manageKyc",
    //   icon: <Icon component={KycIcon} />,
    //   children: [
    //     {
    //       title: "User Tier Levels",
    //       key: "userTierLevels",
    //       url: slugs.user_tier_levels,
    //     },
    //     {
    //       title: "Business Types",
    //       key: "businessTypes",
    //       url: slugs.business_types,
    //     },
    //     // {
    //     //   title: "KYC Settings",
    //     //   key: "kycSettings",
    //     //   url: slugs.kyc_settings,
    //     // },
    //   ],
    // },
    {
      title: "Logs",
      key: "logs",
      icon: <Icon component={PiScrollLight} />,
      children: [
        {
          title: "Dispute",
          key: "dispute",
          url: slugs.dispute,
        },
        /*{
          title: "Third Party Disputes",
          key: "third_party_disputes",
          url: slugs.third_party_dispute_log,
        },*/
        // {
        //   title: "Requests Log",
        //   key: "requests_log",
        //   url: slugs.requests_logs,
        // },
        {
          title: "Pending Requests Log",
          key: "pendingRequestsLog",
          url: slugs.pending_requests_log,
        },
        {
          title: "Activity Logs",
          key: "activityLogs",
          url: slugs.activity_logs,
        },
        {
          title: "Audit Trail",
          key: "auditTrail",
          url: slugs.audit_trail,
        },
        {
          title: "Regulatory Reporting",
          key: "regulatoryReporting",
          url: slugs.regulatory_reporting,
        },
        {
          title: "Internal Reporting",
          key: "internalReporting",
          url: slugs.internal_reporting,
        },
        {
          title: "Category Change Requests",
          key: "categoryChangeRequests",
          url: slugs.category_change_requests,
        },
        // {
        //   title: "Admin Audit Log",
        //   key: "admin_audit_log",
        //   url: slugs.admin_audit,
        // },
      ],
    },
    {
      title: "Manage Cards",
      key: "cards",
      icon: <Icon component={PiCreditCardLight} />,
      children: [
        {
          title: "Cards",
          key: "dispute",
          url: slugs.cards,
        },
        {
          title: "Bulk Card",
          key: "bulkcards",
          url: slugs.bulk_cards,
        },
      ],
    },
    {
      title: "QR Codes",
      key: "qrCode",
      icon: <Icon component={PiQrCodeLight} />,
      url: slugs.qr_codes,
    },
    // {
    //   title: "OTP",
    //   key: "otp",
    //   icon: <Icon component={OtpIcon} />,
    //   url: slugs.otp,
    // },

    // {
    //   title: "Tech",
    //   key: "trading",
    //   icon: <Icon component={TechIcon} />,
    //   children: [
    //     {
    //       title: "Tech Admin Vendors",
    //       key: "techAdminVendors",
    //       url: slugs.tech_admin,
    //     },
    //     {
    //       title: "Pricing",
    //       key: "pricing",
    //       url: slugs.tech_pricing,
    //     },
    //     {
    //       title: "Commission",
    //       key: "commission settings",
    //       url: slugs.agre_bill,
    //     },
    /*{
      title: "Agregator Bill",
      key: "agregatorBill",
      url: slugs.agre_bill,
    },
   /* {
      title: "Tech Overview",
      key: "techOverview",
      url: slugs.overview_tech,
    },
   /* {
      title: "Simulated Users",
      key: "simulatedUsers",
      url: slugs.tech_users_overview,
    },
    /*{
      title: "CRM",
      key: "crm",
      url: slugs.crm,
    },
    {
      title: "Invoice / Receipt",
      key: "invoice",
      url: slugs.reciepts,
    },*/
    /*{
      title: "Third Party Acess",
      key: "thirdParty",
      url: slugs.corp,
    },
    {
      title: "Tech Key Account Prices",
      key: "techKeyAccount",
      url: slugs.api_key,
    },*/
    //   ],
    // },
    {
      title: "Waya Official",
      key: "wayaOfficail",
      icon: <Icon component={PiBankLight} />,
      url: slugs.waya_official,
    },
    {
      title: "Settings",
      key: "settings",
      icon: <Icon component={PiGearLight} />,
      children: [
        {
          title: "App Settings",
          key: "appSettings",
          url: slugs.app_settings,
        },
        {
          title: "Vendors Configuration",
          key: "vendorSettings",
          url: slugs.vendor_settings,
        },
        {
          title: "OTP Management",
          key: "otpManagement",
          url: slugs.otp_management,
        },
        {
          title: "Fees Configuration",
          key: "feesConfiguration",
          url: slugs.fees_configuration,
          roles: ["SUPER_ADMIN"],
        },
        {
          title: "POS Target Config",
          key: "posTargetConfig",
          url: slugs.pos_target_config,
          roles: ["SUPER_ADMIN"],
        },
      ],
    },
    {
      title: "Loan",
      key: "loan",
      icon: <Icon component={PiHandCoinsLight} />,
      children: [
        {
          title: "Loan Dashboard",
          key: "loan",
          url: slugs.loan_admin_dashboard,
        },
        {
          title: "All Loans",
          key: "loan_admin",
          url: slugs.all_loans_admin,
        },
        {
          title: "Pending Loan",
          key: "loanP",
          url: slugs.loan_approval_dashboard,
        },
        {
          title: "Loan Disbursements",
          key: "loanD",
          url: slugs.loan_disbursement_dashboard,
          roles: ['OWNER', 'SUPER_ADMIN', 'finance_approver', 'loan_disbursement'],
        },
        {
          title: "Loan Admins",
          key: "loanAdmins",
          url: slugs.loan_admins,
        },
        {
          title: "Loan Settings",
          key: "loanSettings",
          url: slugs.loan_settings,
        },
        {
          title: "Audit Logs",
          key: "loanAuditLogs",
          url: slugs.loan_audit_logs,
          // roles: ['OWNER', 'SUPER_ADMIN'],
        },
      ],
    },
    {
      title: "B2B Products",
      key: "b2bProducts",
      icon: <Icon component={PiPackageLight} />,
      children: [
        {
          title: "Products List",
          key: "productsList",
          url: slugs.b2b_products,
        },
        {
          title: "Reports",
          key: "b2bReports",
          url: slugs.b2b_reports,
        },
      ],
    },
    {
      title: "Campaign & Promotion",
      key: "campaigns",
      icon: <Icon component={PiMegaphoneLight} />,
      roles: ['MARKETER', 'OWNER', 'SUPER_ADMIN'],
      children: [
        {
          title: "All Campaigns",
          key: "allCampaigns",
          url: slugs.campaigns,
        },
        // {
        //   title: "Active Campaigns",
        //   key: "activeCampaigns",
        //   url: slugs.active_campaigns,
        // },
        // {
        //   title: "Create Campaign",
        //   key: "createCampaign",
        //   url: slugs.create_campaign,
        // },
      ],
    },
    {
      title: "Dispute Management",
      key: "disputeManagement",
      icon: <Icon component={PiShieldCheckLight} />,
      roles: ['OWNER', 'SUPER_ADMIN', 'USER'],
      children: [
        {
          title: "Register Admin",
          key: "registerDisputeAdmin",
          url: slugs.register_dispute_admin,
        },
      ],
    },
    {
      title: "Reporting",
      key: "reporting",
      icon: <Icon component={PiScrollLight} />,
      children: [
        {
          title: "Customer Reports",
          key: "customerManagementReports",
          url: slugs.customer_reports,
        },
        {
          title: "Corporate Reports",
          key: "corporateCustomerReports",
          url: slugs.corporate_customer_reports,
        },
      ],
    },
    /* {
       title: "Users Features",
       key: "usersFeatures",
       icon: <Icon component={UserFeaturesIcon} />,
       url: slugs.users_feature,
     },*/
    // {
    //   title: "Contents",
    //   key: "contents",
    //   icon: <Icon component={ContentIcon} />,
    //   children: [
    //     {
    //       title: "Terms and Conditions",
    //       key: "termsCondition",
    //       url: slugs.terms_conditions,
    //     },
    //     {
    //       title: "Privacy Policy",
    //       key: "privacy",
    //       url: slugs.privacy,
    //     }
    //   ]
    // },
    // {
    //   title: "FeedBack",
    //   key: "feedback",
    //   icon: <Icon component={TechIcon} />,
    //   url: slugs.feedback,
    // }
    {
      title: "Commission Management",
      key: "commissionManagement",
      icon: <Icon component={PiCoinsLight} />,
      roles: ['OWNER', 'SUPER_ADMIN'],
      children: [
        {
          title: "Commission Types",
          key: "commissionTypes",
          url: slugs.commission_types,
        },
        {
          title: "Commission Configurations",
          key: "commissionConfigurations",
          url: slugs.commission_configurations,
        },
      ],
    },
    {
      title: "Rewards & Earn",
      key: "rewardsEarn",
      icon: <Icon component={PiHandCoinsLight} />,
      roles: ['MARKETER', 'OWNER', 'SUPER_ADMIN'],
      url: slugs.rewards,
    },
  ];
}
